import React, { useEffect, useState } from "react";
import {
  Col,
  Button,
  Card,
  Carousel,
  Modal,
  InputNumber,
  Row,
  Tag,
  Divider,
} from "antd";
import { ShoppingOutlined } from "@ant-design/icons";
import { FormatNumber } from "../Utils/cartmgt";
import { getCartReducer } from "../redux/Reducer/cartReducer";
import { useSelector } from "react-redux";

const ProductCard = ({
  item,
  onAddToCart,
  isloadingAddedCartItem,
  setDetailQtyAdded,
  detailsQtyAdded,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { addCartItems } = useSelector(getCartReducer);

  // Extract promo fields
  const {
    images,
    name,
    amount,
    description,
    status,
    product_type,
    is_promo_product,
    unit,
    promo_amount,
    end_date,
  } = item;

  // Logic to determine if it is a promo
  const isPromo = is_promo_product === 1;

  const handleAddToCart = () => {
    onAddToCart(item);
  };

  const showAddToCartModal = () => {
    setIsModalVisible(true);
    setDetailQtyAdded(isPromo ? unit : 50); // Pre-fill with promo unit if it's a deal
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setDetailQtyAdded(50);
  };

  const increaseQty = () => {
    setDetailQtyAdded(detailsQtyAdded + 1);
  };

  const decreaseQty = () => {
    if (detailsQtyAdded > 1) {
      setDetailQtyAdded(detailsQtyAdded - 1);
    }
  };

  const addCartItemsStatus = addCartItems?.status ?? null;
  useEffect(() => {
    if (addCartItems && addCartItems.status === true) {
      setIsModalVisible(false);
    }
  }, [addCartItemsStatus, addCartItems]);

  return (
    <Col
      xs={{ span: 24 }}
      sm={{ span: 12 }}
      md={{ span: 8 }}
      lg={{ span: 8 }}
      xl={{ span: 6 }}
      key={item.id}
    >
      <Card
        hoverable
        className="productcard"
        style={{
          // Apply Gold Border if Promo
          border: isPromo ? "2px solid #D4AF37" : "1px solid #f0f0f0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* === PROMO BADGE === */}
        {isPromo && (
          <div
            style={{
              position: "absolute",
              top: "10px",
              left: "0",
              zIndex: 10,
              backgroundColor: "#D4AF37",
              color: "#fff",
              padding: "4px 12px",
              fontSize: "12px",
              fontWeight: "bold",
              borderRadius: "0 4px 4px 0",
              boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
            }}
          >
            PROMO DEAL
          </div>
        )}

        <div onClick={showModal} className="carousel-wrapper">
          <Carousel
            autoplay
            autoplaySpeed={2500}
            dots={false}
            className="carousel-container"
          >
            {images.map((image, index) => (
              <img key={index} alt={`product-imag-${index}`} src={image.url} />
            ))}
          </Carousel>
        </div>
        <div className="dashboardcardcontent">
          {product_type.id === 1 ? (
            <Button
              type="text"
              className="typography dashboardnibblescardbutton1"
            >
              <p className="dashboardnibblesbutton1typog">
                {product_type.name}
              </p>
            </Button>
          ) : (
            <Button
              type="text"
              className="typography dashboardnibblescardbutton2"
            >
              <p className="dashboardnibblesbutton2typog">
                {product_type.name}
              </p>
            </Button>
          )}

          <p
            className="dashboardtitlescardtypog"
            style={{ marginBottom: "5px" }}
          >
            {name}
          </p>

          {/* === PROMO DEAL TEXT === */}
          {isPromo && (
            <div
              style={{
                marginBottom: "5px",
                color: "#D4AF37",
                fontWeight: "bold",
                fontSize: "13px",
                textAlign: "left",
              }}
            >
              Buy {unit} @ {FormatNumber(promo_amount)}
            </div>
          )}

          <div className="dashboardcardpriceandcartdiv">
            <p
              className="dashboardcarddescriptiontypog"
              style={{ textDecoration: isPromo ? "none" : "none" }}
            >
              {FormatNumber(amount)}{" "}
              {isPromo && (
                <span
                  style={{
                    fontSize: "10px",
                    color: "#999",
                    fontWeight: "normal",
                  }}
                >
                  / unit
                </span>
              )}
            </p>
            <Button
              className="typography addtocartbutton"
              onClick={showAddToCartModal}
              disabled={isloadingAddedCartItem}
            >
              +
            </Button>
          </div>
        </div>
      </Card>

      <Modal
        title={""}
        centered
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        footer={null}
      >
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
        >
          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 9 }}
            lg={{ span: 9 }}
            xl={{ span: 9 }}
          >
            <Carousel
              autoplay
              autoplaySpeed={2500}
              dots={true}
              className="carousel-container-modal"
            >
              {images.map((image, index) => (
                <img
                  key={index}
                  alt={`product-imag-${index}`}
                  src={image.url}
                />
              ))}
            </Carousel>
          </Col>

          <Col
            xs={{ span: 24 }}
            sm={{ span: 12 }}
            md={{ span: 15 }}
            lg={{ span: 15 }}
            xl={{ span: 15 }}
          >
            <div className="ml-4">
              <p className="fw-bold productdescriptionmodaltitle">
                {name}{" "}
                <span>
                  {status === 1 ? (
                    <Tag color="green">In Stock</Tag>
                  ) : (
                    <Tag color="red">Not Available</Tag>
                  )}
                  {isPromo && (
                    <Tag color="gold" style={{ marginLeft: "5px" }}>
                      Promo Deal
                    </Tag>
                  )}
                </span>
              </p>

              <div className="d-flex align-items-baseline">
                <p
                  className="productdescriptionmodalpriceview"
                  style={{ marginRight: "15px" }}
                >
                  <strong>{FormatNumber(amount)}</strong>{" "}
                  <span style={{ fontSize: "14px", color: "#888" }}>
                    per unit
                  </span>
                </p>

                {isPromo && (
                  <div
                    style={{
                      backgroundColor: "rgba(212, 175, 55, 0.1)",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      border: "1px dashed #D4AF37",
                    }}
                  >
                    <span style={{ color: "#D4AF37", fontWeight: "bold" }}>
                      🔥 Deal: Buy {unit} units for {FormatNumber(promo_amount)}
                    </span>
                  </div>
                )}
              </div>

              <Divider />
              <p className="productdescriptionmodaldescriptionview">
                {description}
              </p>
              {isPromo && end_date && (
                <p style={{ fontSize: "12px", color: "red" }}>
                  Promo ends on: {new Date(end_date).toLocaleDateString()}
                </p>
              )}
              <Divider />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div className="productdescriptionmodalqtybtndiv">
                  <Button
                    shape="circle"
                    onClick={decreaseQty}
                    style={{ marginRight: "10px" }}
                    className="productdescriptionmodalqtybtn"
                  >
                    -
                  </Button>
                  <InputNumber
                    min={1}
                    value={detailsQtyAdded}
                    onChange={(value) => setDetailQtyAdded(value)}
                  />
                  <Button
                    shape="circle"
                    onClick={increaseQty}
                    style={{ marginLeft: "10px" }}
                    className="productdescriptionmodalqtybtn"
                  >
                    +
                  </Button>
                </div>
                <Button
                  type="primary"
                  onClick={handleAddToCart}
                  disabled={isloadingAddedCartItem}
                  size="large"
                  className="productdescriptionmodaladdtocartbtn"
                  iconPosition={"start"}
                  icon={<ShoppingOutlined />}
                  style={{
                    backgroundColor: isPromo ? "#D4AF37" : undefined,
                    borderColor: isPromo ? "#D4AF37" : undefined,
                  }}
                >
                  Add to Cart
                </Button>
              </div>
            </div>
            <small>
              <span className="fw-bold"> Product Type:</span>{" "}
              {product_type.name}
            </small>
          </Col>
        </Row>
      </Modal>
    </Col>
  );
};

export default ProductCard;
